// ProjectManager.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import ProjectTable from "./ProjectTable";
import Header from "./Header";
import { useMsal } from "@azure/msal-react";
import { useLocalStorage } from "../useLocalStorage";
import LoadingModal from "./LoadingModal";


//initialProjects
export default function ProjectManager() {

  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState();
  const [nameReport, setnameReport] = useLocalStorage('nameReport',null);
  //const [proyectos, setProyectos] = useState([]);
  const servidor = "https://analytics-bi.azurewebsites.net";
  //const servidor = "http://localhost:3000";

  const { instance } = useMsal();

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      return accounts[0]; // Toma la primera cuenta autenticada
    }
    return null;
  };

   const userAuth = getAccountInfo();

   const user = {
    name: userAuth.name,
    email: userAuth.username, // Cambia a la URL de la foto del usuario
  };

    const handleLogout = () => {
    instance.logoutRedirect({
     //postLogoutRedirectUri: "http://localhost:3000", // Cambia esto según tu entorno
     //postLogoutRedirectUri: "https://analytics.centenario.com.pe", // Cambia esto según tu entorno
                            });
    };

  const toggleActive = (id) => {
    setProjects((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, activo: !p.activo, reemplazar_por: null } : p
      )
    );
  };

  const reassignProject = (id, newProjectId) => {
    setProjects((prev) =>
      prev.map((p) => (p.id === id ? { ...p, reemplazar_por: newProjectId } : p))
    );
  };

  const handleSaveChanges = async () => {
    try {

      for (const items of projects) 
      {
        const { activo: bactivo,reemplazar_por : idproyectonew } = items;

        if((bactivo == false && idproyectonew == null) || idproyectonew == 0)
        {
          alert("Debe seleccionar un proyecto válido ❌");
          return ;
        }
      }

      setLoading(true); // Bloquear pantalla
        //console.log(projects,user.email);
      const response = await fetch(`${servidor}/api/savemaestros`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ proyectos: projects, usuario: user.email }),
      });

      if (!response.ok) throw new Error("Error al guardar cambios");

      alert("Cambios guardados correctamente ✅");
    } catch (error) {
      console.error("Error al enviar datos:", error);
      alert("Ocurrió un error al guardar los cambios ❌");
    } finally {
      setLoading(false); // Desbloquear pantalla
    }
  };

   const fetchData = async () => {
    try {
      const [proyectosRes] = await Promise.all([
        axios.get(`${servidor}/api/proyectos`),
      ]);
      setProjects(proyectosRes.data);
     
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };

  useEffect(() => {
    fetchData();
    setnameReport("Mantenimiento de Proyectos");
    window.dispatchEvent(new Event("storage_name"));

  },[])

  return (
    <div>
      <Header user={user} onLogout={handleLogout}></Header>
     <LoadingModal isOpen={loading} />
      <main className="p-6 max-w-6xl mx-auto" style={{textAlign:"center"}}>
        <br></br>
        <br></br>
        <p className="text-sm text-gray-600 mb-4">
          Activa o desactiva proyectos y asigna uno oficial cuando sea necesario.
        </p>
        <div style={{textAlign:"center"}}>
           {projects!=null ? <ProjectTable
          projects={projects}
          onToggleActive={toggleActive}
          onReassign={reassignProject}
        /> : ""}  

          <button
          onClick={handleSaveChanges}
          className="mt-8 bg-[#A71D2A] text-white px-6 py-2 rounded hover:bg-[#8e1823] transition font-medium"
          disabled={loading}
          >
          Guardar Cambios
        </button>
        </div>
       
      </main>

     
    </div>
  );
}